import { MAX_ADMINS_PER_TENANT } from '@dawn/feature-config';

import { useConfigQuery } from './use-config-query';

/**
 * Live admin + pending-invitation cap, served by the dashboard config endpoint
 * (`maxAdminsPerTenant`, Firestore-overridable). Falls back to the build-time
 * default while config is loading or when the field is absent (e.g. the public,
 * unauthenticated config response).
 */
export function useMaxAdmins(): number {
  const { data } = useConfigQuery();
  return data?.policy.maxAdminsPerTenant ?? MAX_ADMINS_PER_TENANT;
}
